/* ═══════════════════════════════════════════
   FERRARA — Theme JS
   ═══════════════════════════════════════════ */

(function() {
  'use strict';

  /* ── Spam Guard (honeypot + page-load timestamp) ──
     Page load is captured once when this script runs (end of <body>), so any
     submit faster than MIN_ELAPSED_MS after load is treated as a bot. */
  var pageLoadedAt = Date.now();
  var MIN_ELAPSED_MS = 3000;

  function isFerraraSpam(form) {
    if (!form) return false;
    var hp = form.querySelector('[name="ferrara_website"]');
    if (hp && hp.value) return true;
    if (Date.now() - pageLoadedAt < MIN_ELAPSED_MS) return true;
    return false;
  }

  /* ── Scroll Reveal Observer ── */
  var scrollRevealEnabled = window.themeSettings && window.themeSettings.enableScrollReveal !== false;

  if (scrollRevealEnabled) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll('.reveal, .craft-item').forEach(el => {
      revealObserver.observe(el);
    });
  } else {
    // Show all elements immediately when scroll reveal is disabled
    document.querySelectorAll('.reveal, .craft-item').forEach(el => {
      el.classList.add('visible');
    });
  }

  /* ── Sticky Nav ── */
  const nav = document.getElementById('site-header');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 80);
    }, { passive: true });
  }

  /* ── Featured Product Variant Helpers ── */
  function getFeaturedVariants() {
    const el = document.getElementById('featured-product-variants');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch(e) { return []; }
  }

  function getSelectedColor() {
    const active = document.querySelector('.color-swatch.active');
    return active ? active.dataset.name : null;
  }

  function getSelectedSize() {
    const active = document.querySelector('.size-option.active');
    return active ? active.dataset.size : null;
  }

  function updateFeaturedVariant() {
    const variants = getFeaturedVariants();
    if (!variants.length) return;

    const color = getSelectedColor();
    const size = getSelectedSize();

    // Find matching variant
    const match = variants.find(v => {
      const colorMatch = !color || v.options[0] === color;
      const sizeMatch = !size || v.options[1] === size;
      return colorMatch && sizeMatch;
    });

    const variantInput = document.getElementById('selected-variant');
    const cartForm = document.getElementById('featured-cart-form');
    const notifySection = document.getElementById('featured-notify');
    const notifyVariant = document.getElementById('notify-variant');

    if (match) {
      if (variantInput) variantInput.value = match.id;
      if (notifyVariant) notifyVariant.value = match.id;

      if (cartForm && notifySection) {
        if (match.available) {
          cartForm.style.display = '';
          notifySection.style.display = 'none';
        } else {
          cartForm.style.display = 'none';
          notifySection.style.display = '';
        }
      }

      // Update URL
      const url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }

    // Update size availability indicators based on current color
    if (color) {
      document.querySelectorAll('.size-option').forEach(btn => {
        const s = btn.dataset.size;
        const available = variants.some(v => v.options[0] === color && v.options[1] === s && v.available);
        btn.classList.toggle('unavailable', !available);
      });
    }
  }

  /* ── Product Image Carousel ── */
  var carouselIndex = 0;
  var carouselTotal = 0;

  function initCarousel() {
    var slides = document.querySelectorAll('.carousel__slide');
    carouselTotal = slides.length;
    carouselIndex = 0;
    updateCarousel();
  }

  function updateCarousel() {
    var track = document.getElementById('carouselTrack');
    if (track) track.style.transform = 'translateX(-' + (carouselIndex * 100) + '%)';

    // Update dots
    document.querySelectorAll('.carousel__dot').forEach(function(dot, i) {
      dot.classList.toggle('active', i === carouselIndex);
    });

    // Update color name from the active slide
    var activeSlide = document.querySelector('.carousel__slide[data-index="' + carouselIndex + '"]');
    if (activeSlide) {
      var color = activeSlide.dataset.color;
      // Sync the color swatch
      var matchingSwatch = document.querySelector('.color-swatch[data-color="' + color + '"]');
      if (matchingSwatch) {
        document.querySelectorAll('.color-swatch').forEach(function(s) { s.classList.remove('active'); });
        matchingSwatch.classList.add('active');

        var nameEl = document.getElementById('colorName');
        if (nameEl) nameEl.textContent = matchingSwatch.dataset.name;
      }
      updateFeaturedVariant();
    }
  }

  window.carouselNav = function(dir) {
    carouselIndex = (carouselIndex + dir + carouselTotal) % carouselTotal;
    updateCarousel();
  };

  window.carouselGoTo = function(index) {
    carouselIndex = index;
    updateCarousel();
  };

  initCarousel();

  /* ── Product Color Selector ── */
  window.selectProductColor = function(swatch) {
    var color = swatch.dataset.color;
    var name = swatch.dataset.name;

    // Update active swatch
    var container = swatch.closest('.color-selector') || document;
    container.querySelectorAll('.color-swatch').forEach(function(s) { s.classList.remove('active'); });
    swatch.classList.add('active');

    // Update color name display
    var nameEl = document.getElementById('colorName');
    if (nameEl) {
      nameEl.style.opacity = 0;
      setTimeout(function() {
        nameEl.textContent = name;
        nameEl.style.opacity = 1;
      }, 200);
    }

    // Navigate carousel to matching slide
    var slide = document.querySelector('.carousel__slide[data-color="' + color + '"]');
    if (slide) {
      carouselIndex = parseInt(slide.dataset.index, 10);
      var track = document.getElementById('carouselTrack');
      if (track) track.style.transform = 'translateX(-' + (carouselIndex * 100) + '%)';
      document.querySelectorAll('.carousel__dot').forEach(function(dot, i) {
        dot.classList.toggle('active', i === carouselIndex);
      });
    }

    // Update variant based on color + size
    updateFeaturedVariant();
  };

  /* ── Product Size Selector ── */
  window.selectProductSize = function(btn) {
    const size = btn.dataset.size;

    // Don't allow selecting unavailable sizes
    if (btn.classList.contains('unavailable')) return;

    // Update active state
    document.querySelectorAll('.size-option').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    // Update size name display
    const sizeNameEl = document.getElementById('sizeName');
    if (sizeNameEl) sizeNameEl.textContent = size;

    // Update variant based on color + size
    updateFeaturedVariant();
  };

  /* ── Klaviyo Helper ── */
    function klaviyoTrack(eventName, email, properties) {
    var externalId = window.shopifyCustomerId != null ? String(window.shopifyCustomerId) : null;
    var identifyPayload = { email: email };
    if (externalId) identifyPayload.external_id = externalId;

    var klaviyo = window.klaviyo || window._klOnsite || [];
    if (typeof klaviyo.push === 'function') {
      klaviyo.push(['identify', identifyPayload]);
      klaviyo.push(['track', eventName, properties]);
      return;
    }

    // Fallback only if klaviyo.js hasn't loaded yet
    var publicKey = document.querySelector('script[src*="klaviyo.js"]');

    if (publicKey) {
      var companyId = new URL(publicKey.src).searchParams.get('company_id');
      if (companyId) {
        var profileAttributes = { email: email };
        if (externalId) profileAttributes.external_id = externalId;
        var payload = JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: eventName } } },
              profile: { data: { type: 'profile', attributes: profileAttributes } },
              properties: properties
            }
          }
        });
        var url = 'https://a.klaviyo.com/client/events/?company_id=' + companyId;
        if (navigator.sendBeacon) {
          navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
        } else {
          fetch(url, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
            body: payload,
            keepalive: true
          }).catch(function() {});
        }

      }
    }
  }

  /* ── Notify Me (Back in Stock) ── */
  window.subscribeNotify = async function(form) {
    if (isFerraraSpam(form)) return;

    const button = form.querySelector('[type="submit"]');
    const emailInput = form.querySelector('[name="email"]');
    const variantInput = form.querySelector('[name="variant"]');
    const email = emailInput ? emailInput.value.trim() : '';

    if (!email) return;

    button.textContent = 'SUBMITTING...';
    button.disabled = true;

    try {
      klaviyoTrack('Back in Stock Request', email, {
        email: email,
        variant_id: variantInput ? variantInput.value : 'N/A',
        product: document.title,
        url: window.location.href
      });

      button.textContent = 'SUBSCRIBED';
      emailInput.value = '';
    } catch (error) {
      button.textContent = 'ERROR — TRY AGAIN';
    }

    setTimeout(() => {
      button.textContent = 'Notify Me';
      button.disabled = false;
    }, 3000);
  };

  /* ── Catalog Inquiry ── */
  window.submitCatalogInquiry = async function(form) {
    if (isFerraraSpam(form)) return;

    const button = form.querySelector('[type="submit"]');
    const emailInput = form.querySelector('[name="email"]');
    const productName = form.querySelector('[name="product"]');
    const email = emailInput ? emailInput.value.trim() : '';

    if (!email) return;

    button.textContent = 'SUBMITTING...';
    button.disabled = true;

    try {
      klaviyoTrack('Catalog Inquiry', email, {
        email: email,
        product: productName ? productName.value : document.title,
        url: window.location.href
      });

      button.textContent = 'SUBMITTED';
      emailInput.value = '';
    } catch (error) {
      button.textContent = 'ERROR — TRY AGAIN';
    }

    setTimeout(() => {
      button.textContent = 'Inquire';
      button.disabled = false;
    }, 3000);
  };

  /* ── Add to Cart (AJAX) ── */
  window.addToCart = async function(form) {
    const formData = new FormData(form);
    const button = form.querySelector('[type="submit"]');
    const originalText = button.textContent;

    button.textContent = 'ADDING...';
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        button.textContent = 'ADDED';
        // Update cart count in header
        updateCartCount();
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      } else {
        button.textContent = data.description || 'ERROR';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      }
    } catch (error) {
      button.textContent = originalText;
      button.disabled = false;
    }
  };

  /* ── Update Cart Count ── */
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const countEls = document.querySelectorAll('.cart-count');
      const cartLinks = document.querySelectorAll('.header__cart');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      cartLinks.forEach(el => {
        el.classList.toggle('has-items', cart.item_count > 0);
      });
    } catch (e) {}
  }
  window.updateCartCount = updateCartCount;

  // Initialize cart count on load
  updateCartCount();

  /* ── FAQ Accordion ── */
  document.querySelectorAll('.faq__question').forEach(button => {
    button.addEventListener('click', () => {
      const item = button.closest('.faq__item');
      const answer = item.querySelector('.faq__answer');
      const isOpen = item.classList.contains('is-open');

      if (isOpen) {
        answer.style.maxHeight = '0';
        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      } else {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Collection Filter Dropdowns ── */
  document.querySelectorAll('[data-filter-toggle]').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var group = toggle.closest('[data-filter-group]');
      var isOpen = group.classList.contains('is-open');

      // Close all other dropdowns
      document.querySelectorAll('[data-filter-group]').forEach(function(g) {
        g.classList.remove('is-open');
        g.querySelector('[data-filter-toggle]').setAttribute('aria-expanded', 'false');
      });

      // Toggle current
      if (!isOpen) {
        group.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-filter-group]')) {
      document.querySelectorAll('[data-filter-group]').forEach(function(g) {
        g.classList.remove('is-open');
        g.querySelector('[data-filter-toggle]').setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ── Mobile Video Autoplay Fix ── */
  const videoAutoplayObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.play().catch(() => {});
      } else {
        entry.target.pause();
      }
    });
  }, { threshold: 0.25 });

  document.querySelectorAll('video[autoplay]').forEach(video => {
    videoAutoplayObserver.observe(video);
  });

  /* ── Smooth Scroll for Anchor Links ── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

})();
